/**
 * Labstep
 *
 * @module components/EntityView/Filter/Pane
 * @desc Filter pane for EntityView
 */

import { FilterPane } from 'labstep-web/components/Filter/Pane';
import { Filter } from 'labstep-web/constants/filters';
import { ICONS } from 'labstep-web/constants/icons';
import { EntityView } from 'labstep-web/models/entity-view.model';
import type React from 'react';

export const EntityViewFilterPane: React.FC = () => (
  <FilterPane
    entityName={EntityView.entityName}
    filters={[Filter.created_by, Filter.tag]}
    icon={ICONS.entity_view.primary}
    text="Filters"
  />
);
